export default __webpack_public_path__ + "static/media/c007-bg.7234438d.jpg";